import { motion } from "framer-motion";
import { COVER_IMG } from "@/lib/api";

export const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen flex items-center overflow-hidden pt-16">
      <div
        className="absolute inset-0 bg-cover bg-center grayscale"
        style={{ backgroundImage: "url(https://images.unsplash.com/photo-1689877020200-403d8542d95d?q=80&w=1600)" }}
      />
      <div className="absolute inset-0 bg-black/80" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(circle at 70% 40%, rgba(217,4,41,0.22) 0%, transparent 55%)" }}
      />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 grid lg:grid-cols-2 gap-16 items-center w-full">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="section-label mb-6">// NO EXCUSES. NO MERCY. //</p>
          <h1 className="font-anton text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tight leading-none">
            <span className="neon-text flicker">AIN'T DEAD</span>
            <br />
            <span className="text-[#F5F5F5]">YET</span>
          </h1>
          <h2 className="font-bebas text-2xl sm:text-3xl text-[#D90429] tracking-[0.25em] mt-4 uppercase">
            Anime Physique Program
          </h2>
          <p className="text-[#A1A1AA] max-w-md mt-6 text-base leading-relaxed">
            If you ain't dead yet, you ain't done yet. An 8-week hypertrophy war plan forged for those who refuse to
            stay average.
          </p>
          <div className="flex flex-wrap gap-6 mt-10">
            <a href="#pricing" data-testid="hero-cta-buy" className="btn-brutal">
              Start Grinding — €19.99
            </a>
            <a href="#program" data-testid="hero-cta-learn" className="btn-brutal btn-brutal-outline">
              Learn More
            </a>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="order-first lg:order-last"
        >
          <div className="corner-marks max-w-[280px] sm:max-w-[340px] mx-auto lg:max-w-none">
            <div className="absolute -inset-4 bg-[#D90429]/25 blur-3xl pulse-glow" />
            <img
              src={COVER_IMG}
              alt="Anime Physique Program cover"
              data-testid="hero-cover-image"
              className="relative border-2 border-[#2A2A2A] w-full object-cover"
            />
          </div>
        </motion.div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 font-jet text-[10px] tracking-[0.4em] text-[#52525B]">
        SCROLL TO SURVIVE ▼
      </div>
    </section>
  );
};
